"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.assign");

var _classCallCheck = require("/home/forge/imf-2020.cantilever.co/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/forge/imf-2020.cantilever.co/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/forge/imf-2020.cantilever.co/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/forge/imf-2020.cantilever.co/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/forge/imf-2020.cantilever.co/node_modules/@babel/runtime/helpers/getPrototypeOf");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _htmlTags = _interopRequireDefault(require("html-tags"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var omit = function omit(keys, obj) {
  var obj2 = {};

  for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];

    if (!keys.includes(key)) {
      obj2[key] = obj[key];
    }
  }

  return obj2;
};

var Safe = _htmlTags.default.reduce(function (tags, tag) {
  tags[tag] = /*#__PURE__*/function (_react$default$Compon) {
    _inherits(Tag, _react$default$Compon);

    var _super = _createSuper(Tag);

    function Tag() {
      _classCallCheck(this, Tag);

      return _super.apply(this, arguments);
    }

    _createClass(Tag, [{
      key: "render",
      value: function render() {
        var props = this.props;
        return _react.default.createElement(tag, Object.assign(omit(["children"], props), {
          dangerouslySetInnerHTML: {
            __html: props.children
          }
        }));
      }
    }]);

    return Tag;
  }(_react.default.Component);

  return tags;
}, {});

var _default = Safe;
exports.default = _default;